import { useState } from "react";
import { Controller } from "react-hook-form";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export const PasswordField = ({
  name,
  label,
  control,
  helperText,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, ...field }, fieldState: { error } }) => (
        <TextField
          {...field}
          {...props}
          error={!!error}
          fullWidth
          helperText={error?.message || helperText}
          label={label}
          onChange={(e) => onChange(e.target.value.replace(/\s/g, ""))}
          required
          type={showPassword ? "text" : "password"}
          slotProps={{
            htmlInput: { tabIndex: 8 },
            input: {
              autoComplete: "new-password",
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseDown={(e) => e.preventDefault()}
                    edge="end"
                    tabIndex={10}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />
      )}
    />
  );
};
